import {AfterViewInit, Component, isDevMode, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import '@angular/common/locales/global/pl';

import {DeviceDetectorService} from "ngx-device-detector";
import {pl} from 'date-fns/locale';
import setDefaultOptions from 'date-fns/setDefaultOptions';
import { filter, Observable } from 'rxjs';

import {CountryCodeService} from '@commons/services/country.code/country-code.service';

import {OfflineDialogComponent} from "@shared/components/offline-dialog/offline-dialog.component";
import {DialogService} from "@shared/services/dialog.service";
import {HotjarService} from '@shared/services/external-scripts/hotjar.service';
import { IfAddressIsAvailableOnThePhonePipe } from '@shared/pipes/if-address-is-available-on-the-phone.pipe';
import { TawkToChatService } from '@shared/services/tawk-to-chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  encapsulation: ViewEncapsulation.None,
  providers: [IfAddressIsAvailableOnThePhonePipe],
})
export class AppComponent implements OnInit, AfterViewInit {

  isMobile = this.deviceDetectorService.isMobile();
  isVisibleNotSupportedMobileOsMessage = false;

  public onRouterChange$: Observable<NavigationEnd> = this.router.events.pipe(filter<any>(event => event instanceof NavigationEnd));

  constructor(
    private countryCodeService: CountryCodeService,
    private router: Router,
    private dialogService: DialogService,
    private deviceDetectorService: DeviceDetectorService,
    private hotjarService: HotjarService,
    private ifAddressIsAvailableOnThePhonePipe: IfAddressIsAvailableOnThePhonePipe,
    private tawkToChatService: TawkToChatService
  ) {
    // if (isDevMode())
    //   this.router.events.subscribe(x => console.log(x));
    this.initLibraries();
  }

  ngOnInit() {
    this.onChangeRoute();
    this.dectectOfflineMode();
  }

  ngAfterViewInit(): void {
    this.subscribeToGoogleAnalytics();
  }

  private onChangeRoute(): void {
    this.onRouterChange$.subscribe(value => {
      if (value) {
        const ifMobileAndRouteDontAvailableInMobileDevice = this.isMobile && !this.ifAddressIsAvailableOnThePhonePipe.transform(value.urlAfterRedirects);
        if (ifMobileAndRouteDontAvailableInMobileDevice) {
          this.openMobileStore();
        }
      }
    });
  }

  private initLibraries(): void {
    this.setDateFnsDefaultOptions();
    this.countryCodeService.loadCodes().subscribe();
    this.subscribeToGoogleAnalytics();
    this.hotjarService.tryInject();
    this.tawkToChatService.onStatusChange();
  }

  private setDateFnsDefaultOptions() {
    setDefaultOptions({locale: pl})
  }

  private dectectOfflineMode() {
    window.addEventListener("load", () => {
      let showOffline = false;

      window.addEventListener("online", () => showOffline = false);
      window.addEventListener("offline", () => {
        showOffline = true;
        setTimeout(() => {
          if (showOffline)
            this.dialogService.open(OfflineDialogComponent);
        }, 20000);
      });
    });
  }

  private subscribeToGoogleAnalytics() {
    if (isDevMode())
      return;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }

  private openMobileStore() {
    const osName = this.deviceDetectorService.os.toLocaleLowerCase();
    if (osName.startsWith('android')) {
      window.location.replace('https://play.google.com/store/apps/details?id=pl.tekom.mycarbiz');
    } else if (osName.startsWith('ios'))
      window.location.replace('https://apps.apple.com/pl/app/mycar-business/id1062582464');
    else
      this.isVisibleNotSupportedMobileOsMessage = true;
  }
}

if (typeof Worker !== 'undefined') {
  const worker = new Worker(new URL('./app.worker', import.meta.url));
  worker.onmessage = ({ data }) => {
    console.log(`page got message: ${data}`);
  };
  worker.postMessage('hello');
} else {
  // Web Workers are not supported in this environment.
}